import { render, staticRenderFns } from "./ds-export.vue?vue&type=template&id=77a67b61&"
import script from "./ds-export.vue?vue&type=script&lang=js&"
export * from "./ds-export.vue?vue&type=script&lang=js&"
import style0 from "./ds-export.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports